import { PAYMENT_COLLACTION_TYPE } from 'src/app/constants/payment.constant';
import { TokenizedResponse } from './token.models';

export class ChargeCard {
  patientId: number;
  practiceId: number;
  customerId: number;
  providerId: number;
  amount: string;
  bankName: string;
  individualName: string;
  tokenizeResponse: TokenizedResponse = new TokenizedResponse();
  billingInformation: BillingInformation = new BillingInformation();
  subject: string;
  note: string;
  isPrePayment: boolean = false;
  pmsPaymentType: number;
  testTransaction: boolean = false;
  transactionCollectionType?: PAYMENT_COLLACTION_TYPE;
  moduleType?: number;
  paymentPlanId?: number;
  paymentPlanEmiId?: number;
  ownerType?: number; // 1 for Patient, 2 for Practice
  taxPercentage?: number = 0;
  taxAmount?: number = 0; 
  grossAmount?: number = 0; // Total amount before tax
  patientName?:string='';
  retriedForTransactionId?:number | any = null; // For Fix It,
  emiTransactionType? : number;
  isForPayNow: boolean = false;
  payNowCorrelationId?: string;
  cardToken?: string;
  payNowLookUpType?: number;
}

export class BillingInformation {
  billingAddressId?: number = 0;
  country: string;
  city: string;
  state: string;
  address1: string;
  address2?: string;
  zip: string;
  company?: string;
  patientId?: number;
  tokenId?: number;
  transactionId?: number;
}

export class PaymentAPIResponse {
  isSuccess: boolean = false;
  message: string = '';
  transactionId?: string = '';
  clearentTransactionId?: string = '';
  data?: any;
  errors?: any;
  // Task 3537: a full refund above the practice's limit was sent for approval instead of being processed.
  requiresApproval?: boolean;
  approverRoleName?: string | null;
}

export class CashPayment {
  patientId: number;
  practiceId: number;
  customerId: number;
  providerId: number;
  amount: number;
  subject: string;
  note: string;
  individualName: string;
  createdBy: string;
  pmsPaymentType: number;
  transactionCollectionType?: PAYMENT_COLLACTION_TYPE;
  moduleType?: number;
  paymentPlanId?: number;
  patientName?:string='';
  ownerType?:number;
  emiTransactionType? : number;
}

export class TerminalPayment {
  terminalId: number;
  patientId: number;
  practiceId: number;
  providerId: number;
  customerId: number;
  amount: string;
  createToken: boolean = false;
  subject: string;
  note: string;
  individualName: string;
  isPrePayment: boolean = false;
  pmsPaymentType: number;
  transactionCollectionType?: PAYMENT_COLLACTION_TYPE;
  moduleType?: number;
  paymentPlanId?: number;
  paymentPlanEmiId?: number;
  description?: string = '';
  patientName?:string='';
  ownerType?:number;
  retriedForTransactionId?:number[] | any = null; // For Fix It
  emiTransactionType? : number;
}

export class SchedulePayment {
  chargedDate: string;
  amount: number = 0;
  paymentMethod: string;
  lastFourDigit?: string = '****';
  cardType?: string = '';
  transactionId?: string | number;
  tokenType?: number;
  status?: string;
}

export class ClearentCustomer {
  customerId: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  patientId: number;
  providerId: number;
}

export class SendPaymentLink {
  customerId: number;
  patientId: number;
  providerId: number;
  patientName: string;
  practiceId: number;
  phone: string;
  emailAddress: string;
  amount: number;
  subject: string;
  note: string;
  isPrePayment: boolean = false;
  pmsPaymentType: number;
  transactionCollectionType?: PAYMENT_COLLACTION_TYPE;
  moduleType?: number;
  paymentPlanId?: number;
  paymentPlanEmiId?: number;
  description?: string = '';
  ownerType?:number;
  retriedForTransactionId?:number[] | any = null; // For Fix It
  smsTemplateId?: number;
  emailTemplateId?: number;
  isEmailSend?: boolean;
  isSmsSend?: boolean;
  emiTransactionType? :number;
}

export class CheckPayment {
  customerId: number;
  patientId: number;
  practiceId: number;
  amount: number;
  providerId: number;
  checkDate: string;
  individualName: string;
  bankName: string;
  accountType: string;
  checkNumber: string;
  subject: string;
  note: string;
  pmsPaymentType: number;
  transactionCollectionType?: PAYMENT_COLLACTION_TYPE;
  moduleType?: number;
  patientName?:string='';
  ownerType?:number;
  paymentPlanId?: number;
  emiTransactionType? : number;
}

export class RefundTransactionReqCommand {
  transactionId: number;
  pmsTransactionId: number;
}


export class Order {
  orderId?: number = 0;
  practiceId?: number;
  chainId?: number;
  subscribedSubscriptionIds: string;
  subTotal: number;
  totalDiscount: number;
  communicationEmailLimit?: number = 0;
  communicationSMSLimit?: number = 0;
  communicationEmailOverageCharges?: number = 0;
  communicationSmsOverageCharges?: number = 0;
  totalMonthlySubscriptionCharges: number;
  onboardingDiscount: number;
  oneTimeSetupFee: number;
  taxTotal: number;
  netTotal: number;
  billedFromName: string;
  billedFromStreet: string;
  billedFromCity: string;
  billedFromState: string;
  billedFromCountry: string;
  billedFromZip: string;
  billedFromEmail: string;
  billedFromPhone: string;
  shippingStreet: string;
  shippingCity: string;
  shippingState: string;
  shippingCountry: string;
  shippingZip: string;
  shippingEmail: string;
  shippingPhone: string;
  orderDate?: any;
  createdDate?: Date;
  updatedDate?: Date;
  createdBy?: number;
  updatedBy?: number;
  orderNumber?: string;
  initialPeriodStartDate?: Date;
  initialPeriodEndDate?: Date;
  firstRenewalDate?: Date;
  authorizedName?: string;
  authorizedTitle?: string;
  authorizedEmail?: string;
  orderStatus?: number;
  pricingPlanId?: number;
  signature?: string;
  orderAcceptanceDate?: Date;
}

export class SubscriptionInvoice {
  invoiceId?: number = 0;
  practiceId?: number;
  chainId?: number;
  orderId?: number;
  subscribedSubscriptionIds: string;
  subTotal: number;
  totalDiscount: number;
  totalMonthlySubscriptionCharges: number;
  onboardingDiscount: number;
  oneTimeSetupFee: number;
  taxTotal: number;
  netTotal: number;
  billedFromName: string;
  billedFromStreet: string;
  billedFromCity: string;
  billedFromState: string;
  billedFromCountry: string;
  billedFromZip: string;
  billedFromEmail: string;
  billedFromPhone: string;
  shippingStreet: string;
  shippingCity: string;
  shippingState: string;
  shippingCountry: string;
  shippingZip: string;
  shippingEmail: string;
  shippingPhone: string;
  billedToName: string;
  billedToStreet: string;
  billedToCity: string;
  billedToState: string;
  billedToCountry: string;
  billedToZip: string;
  createdDate?: Date;
  updatedDate?: Date;
  createdBy?: number;
  updatedBy?: number;
  pricingPlanId?: number;
  credits?: number = 0;
  planSubscription?:string;
  period?:string;
  transactionId?:number;
  taxRateTotal?:number=0;
  stateTaxAmount?:number=0;
  stateTaxRate?:number=0;
  localTaxRate?:number=0;
  localTaxAmount?:number=0;

}

export class MapPatientReq{
  transactionId:number;
  patientId:number;
  userId:number;
  providerId:string;
  note:string;
  pmsPaymentType:number;
  patientName?:string='';
}
